<template>
  <div class="editor-container" id="instagram">
    <div class="fixed">
      <EditorMenu />
      <div
        class="glass-preview"
        :data-color="product.attribute_values.color.slug"
      >
        <small v-html="$t('product_description')"></small>
        <div class="glass">
          <div class="glass-inner">
            <div class="topbar">
              <div class="author">
                <div
                  class="account-photo"
                  :class="{
                    'active-stories': product.attributes.activeStories,
                  }"
                >
                  <Image
                    :image-url="profileImageUrl"
                    uploader-id="originalProfile"
                  />
                </div>
                <h5 class="account-name">{{ accountName }}</h5>
                <div
                  v-show="product.attributes.approvedAccount"
                  class="approved"
                />
              </div>
              <div class="dots" />
            </div>
            <div class="image">
              <Image :image-url="imageUrl" />
            </div>
            <div class="actions">
              <div>
                <div
                  v-show="product.attributes.likedPhoto"
                  class="heart-liked"
                />
                <div v-show="!product.attributes.likedPhoto" class="heart" />
                <div class="comment" />
                <div class="message" />
              </div>
              <div class="saved" />
            </div>
            <div class="meta">
              <div class="like">
                <div class="thumbs" />
                <span
                  >{{ $t("It likes") }} <strong>{{ like }}</strong> {{ $t("and") }}
                  <strong>{{ others }}</strong> {{ $t("others") }}</span
                >
              </div>
              <div class="post">
                <strong>{{ accountName }}</strong>
                <span>&nbsp;{{ description }}</span>
              </div>
            </div>
            <Stand />
          </div>
        </div>
      </div>
    </div>
    <div class="product-fields">
       <!-- Sold -->
       <SoldCapacity v-if="soldCapacity"/>
       <!-- Editor -->
      <div class="form-fields">
        <ImageHandler />
        <ImageHandler
          type="profile"
          :uploaded-text="$t('Uploaded profile image')"
          :upload-text="$t('Upload profile image')"
          uploader-namespace="instaUploader/"
          cropper-namespace="instaCropper/"
        />
        <InstaFields />
        <GlobalAttributes />
        <AddToCart />
      </div>
      <Loader />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import AddToCart from "./AddToCart";
import GlobalAttributes from "./attributes/GlobalAttributes";
import InstaFields from "./attributes/InstaFields";
import ProductServices from "./../../../packages/views/product-service/Services";
import useInsta from "../useInsta";
import ImageHandler from "./ImageHandler";
import useProduct from "../useProduct";
import Loader from "../../../packages/views/loader/Loader";
import Image from "./Image";
import EditorMenu from "./EditorMenu.vue";
import Stand from "./Stand.vue";
import SoldCapacity from "./SoldCapacity.vue";

export default {
  components: {
    Image,
    Loader,
    ProductServices,
    InstaFields,
    GlobalAttributes,
    AddToCart,
    ImageHandler,
    EditorMenu,
    Stand,
    SoldCapacity
},
  computed: {
    ...mapGetters({
      product: "product/getProduct",
      soldCapacity: 'product/getSoldCapacity',
    }),
  },
  setup() {
    const { accountName, description, like, others, profileImageUrl } =
      useInsta();
    const { imageUrl } = useProduct();

    return {
      accountName,
      description,
      like,
      others,
      imageUrl,
      profileImageUrl,
    };
  },
};
</script>
